function homeownerTourStorageKey(clientId) {
  return `pacarion_homeowner_tour_done_${clientId || 'unknown'}`;
}

function agentTourStorageKey(profileId) {
  if (!profileId) return null;
  return `pacarion_agent_tour_done_${profileId}`;
}

/**
 * Skip and finish are stored on the homeowner (tutorial_completed) and, if that
 * save fails, in localStorage for this device. An old last_active does not undo it.
 */
function homeownerTourChoiceStored(client, storedValue) {
  if (!client) return false;
  if (client.tutorial_completed === true) return true;
  if (storedValue === true || storedValue === 'true') return true;
  return false;
}

function agentTourChoiceStored(profile, storedValue) {
  if (profile && profile.tour_completed === true) return true;
  if (storedValue === true || storedValue === 'true') return true;
  return false;
}

/** The card, not the tour. Never true while the password dialog is open. */
function shouldOfferHomeownerTour({ hasPassword, passwordDialogOpen, choiceStored, tourOpen }) {
  if (tourOpen || passwordDialogOpen || choiceStored) return false;
  return !!hasPassword;
}

/** First sign-in starts the tour itself. The prompt card is not shown over the questionnaire. */
function shouldAutoStartHomeownerTour(input) {
  const source = input || {};
  return shouldOfferHomeownerTour({
    hasPassword: source.hasPassword,
    passwordDialogOpen: source.passwordDialogOpen,
    choiceStored: source.choiceStored,
    tourOpen: false,
  });
}

/**
 * The year-of-care questions wait until the tour has been finished or skipped.
 * A pending onboarding flag alone must not show them on the first load.
 */
function shouldShowPlanWelcome(client, storedFlag) {
  if (!client || !client.has_password || client.password_reset_required) return false;
  if (client.onboarding_completed_at || client.onboarding_completed) return false;
  return homeownerTourChoiceStored(client, storedFlag);
}

function readStoredFlag(storage, key) {
  if (!storage || !key) return null;
  try {
    return storage.getItem(key);
  } catch (error) {
    return null;
  }
}

function writeStoredFlag(storage, key) {
  if (!storage || !key) return;
  try {
    storage.setItem(key, 'true');
  } catch (error) {
    // A blocked storage write still leaves the in-memory dismissal in place.
  }
}

module.exports = {
  homeownerTourStorageKey,
  agentTourStorageKey,
  homeownerTourChoiceStored,
  agentTourChoiceStored,
  shouldOfferHomeownerTour,
  shouldAutoStartHomeownerTour,
  shouldShowPlanWelcome,
  readStoredFlag,
  writeStoredFlag,
};
